import React from 'react';
import '../../App.css';
import './hsbakbord.css';
import Krijtbord from './components/krijtbord';

function HSBakBord() {
  return (
    <div className="hsbakbord-container">
      <div className="hsbakbord-title-block">
        <h1>Het Huize Sjaars Bak-bord</h1>
      </div>
      <div className="hsbakbord-board-block">
        <Krijtbord />
      </div>
    </div>
  );
}

export default HSBakBord;